import {Fragment } from "react"
import {SkipDays} from "../../calendarBuilder"


export const June = () => {
    return (
        <Fragment>{SkipDays(1, 2, [], false)}</Fragment>  
    )
}